/**
 * Convert markdown / minimal HTML to plain text for SMS.
 *
 * SMS doesn't support formatting — strip the syntax, keep the visible content.
 * Conversion order matters; e.g. links must be unwrapped before emphasis is
 * stripped, otherwise `[**bold**](url)` loses its inner text.
 */
export function markdownToPlainText(input: string): string {
  if (!input) return ''
  let out = input

  // Strip HTML tags if any leaked into the template
  out = out.replace(/<[^>]+>/g, '')

  // Images: ![alt](src) -> alt
  out = out.replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')

  // Links: [text](url) -> text
  out = out.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')

  // Inline code: `code` -> code
  out = out.replace(/`([^`]+)`/g, '$1')

  // Bold/italic emphasis: **x**, __x__, *x*, _x_
  out = out.replace(/(\*\*|__)(.+?)\1/g, '$2')
  // Markdown-escaped underscore (`\_`) — collapse so `{driver\_name}` reads cleanly
  out = out.replace(/\\_/g, '_')
  out = out.replace(/(\*|_)(.+?)\1/g, '$2')

  // Strikethrough ~~x~~
  out = out.replace(/~~(.+?)~~/g, '$1')

  // Block syntax at line starts: heading #, blockquote >, list -/*, numbered list 1.
  out = out.replace(/^[ \t]{0,3}#{1,6}[ \t]+/gm, '')
  out = out.replace(/^[ \t]{0,3}>[ \t]?/gm, '')
  out = out.replace(/^[ \t]{0,3}[-*+][ \t]+/gm, '')
  out = out.replace(/^[ \t]{0,3}\d+\.[ \t]+/gm, '')

  // Horizontal rules (---, ***, ___) on their own line
  out = out.replace(/^[ \t]*([-*_])\1{2,}[ \t]*$/gm, '')

  // Collapse 3+ blank lines into 2 (preserve paragraph breaks)
  out = out.replace(/\n{3,}/g, '\n\n')

  return out.trim()
}
